import Image from './Image';
export default Image;
export { default as Image } from './Image';